// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bdac7464","455":"c11f5091"}[chunkId] + ".chunk.js";
};